/* Codex 2026-07-02: lightweight loader for the cache-busted PDP popup runtime. */
(function() {
  if (window.__fflPdpPopupLoaderInstalled) return;
  window.__fflPdpPopupLoaderInstalled = true;

  var runtimeFile = 'ffl-pdp-popup-actions-runtime-slim-20260701a.js';
  var loaderSrc = document.currentScript && document.currentScript.src ? document.currentScript.src : '';
  var triggerSelector = '[data-codex-ring-preview-open], [data-ffl-gem-guide-open]';
  var loadPromise = window.__fflPdpPopupRuntimePromise || null;
  var idleWarmupScheduled = false;

  function ensureGuideUniformTune() {
    if (document.getElementById('ffl-pdp-guide-uniform-tune-20260701b')) return;

    var style = document.createElement('style');
    style.id = 'ffl-pdp-guide-uniform-tune-20260701b';
    style.textContent = [
      '.ffl-pdp-guide__photo img{transform:scale(1.18)!important}',
      '.ffl-pdp-guide__card[data-ffl-card-id="brilliant"] .ffl-pdp-guide__photo img{transform:scale(1.75)!important}',
      '.ffl-pdp-guide__card[data-ffl-card-id="crushed_ice"] .ffl-pdp-guide__photo img{transform:scale(1.35)!important}'
    ].join('');
    document.head.appendChild(style);
  }

  ensureGuideUniformTune();

  function getTrigger(event) {
    return event && event.target && event.target.closest ? event.target.closest(triggerSelector) : null;
  }

  function hasTrigger() {
    return !!document.querySelector(triggerSelector);
  }

  function getRuntimeUrl() {
    if (loaderSrc) return new URL(runtimeFile, loaderSrc).href;

    var script = document.querySelector('script[src*="ffl-pdp-popup-actions"][src*=".js"]:not([src*="runtime"])');
    if (script && script.src) return new URL(runtimeFile, script.src).href;

    var css = document.querySelector('link[href*="ffl-pdp-popup-actions"][href*=".css"]');
    if (css && css.href) return new URL(runtimeFile, css.href).href;

    return runtimeFile;
  }

  function loadRuntime() {
    if (window.__fflPdpPopupRuntimeLoaded) return Promise.resolve();
    if (loadPromise) return loadPromise;

    loadPromise = new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      script.src = getRuntimeUrl();
      script.defer = true;
      script.onload = function() {
        window.__fflPdpPopupRuntimeLoaded = true;
        ensureGuideUniformTune();
        resolve();
      };
      script.onerror = function() {
        reject(new Error('Unable to load PDP popup runtime'));
      };
      document.head.appendChild(script);
    });

    window.__fflPdpPopupRuntimePromise = loadPromise;
    return loadPromise;
  }

  function warm(event) {
    if (!getTrigger(event)) return;
    loadRuntime().catch(function(error) {
      window.console && console.warn && console.warn(error.message || error);
    });
  }

  function scheduleIdleWarmup() {
    if (idleWarmupScheduled || window.__fflPdpPopupRuntimeLoaded || !hasTrigger()) return;
    idleWarmupScheduled = true;

    var run = function() {
      loadRuntime().catch(function(error) {
        window.console && console.warn && console.warn(error.message || error);
      });
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 1800 });
    } else {
      window.setTimeout(run, 1200);
    }
  }

  function replayClick(button) {
    window.setTimeout(function() {
      ensureGuideUniformTune();
      button.__fflPdpPopupReplay = true;
      button.click();
      window.setTimeout(function() {
        button.__fflPdpPopupReplay = false;
        ensureGuideUniformTune();
      }, 0);
    }, 0);
  }

  document.addEventListener('click', function(event) {
    var button = getTrigger(event);
    if (!button || button.__fflPdpPopupReplay || window.__fflPdpPopupRuntimeLoaded) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    button.setAttribute('aria-busy', 'true');

    loadRuntime().then(function() {
      button.removeAttribute('aria-busy');
      replayClick(button);
    }).catch(function(error) {
      button.removeAttribute('aria-busy');
      window.console && console.error && console.error(error.message || error);
    });
  }, true);

  document.addEventListener('pointerover', warm, true);
  document.addEventListener('focusin', warm, true);
  document.addEventListener('touchstart', warm, { capture: true, passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleIdleWarmup, { once: true });
  } else {
    scheduleIdleWarmup();
  }

  window.addEventListener('load', scheduleIdleWarmup, { once: true });
})();
